import { hoverWouldEraseText, isFullyTransparent } from "./color.js";

//#region src/modules/normalizeThemeColors.ts
const cache = /* @__PURE__ */ new WeakMap();
function normalizeThemeColors(theme) {
	const cached = cache.get(theme);
	if (cached != null) return cached;
	const originalColors = theme.colors ?? {};
	const colors = { ...originalColors };
	const editorBackground = originalColors["editor.background"] ?? theme.bg;
	const editorForeground = originalColors["editor.foreground"] ?? theme.fg;
	const sidebarBackground = originalColors["sideBar.background"] ?? editorBackground;
	const sidebarForeground = originalColors["sideBar.foreground"] ?? editorForeground;
	fill(colors, "editor.background", editorBackground);
	fill(colors, "editor.foreground", editorForeground);
	fill(colors, "sideBar.background", sidebarBackground);
	fill(colors, "sideBar.foreground", sidebarForeground);
	fill(colors, "input.background", originalColors["input.background"] ?? sidebarBackground);
	fill(colors, "sideBarSectionHeader.foreground", originalColors["sideBarSectionHeader.foreground"] ?? sidebarForeground);
	fill(colors, "list.activeSelectionForeground", originalColors["list.activeSelectionForeground"] ?? sidebarForeground);
	fill(colors, "gitDecoration.addedResourceForeground", firstColor(originalColors["gitDecoration.addedResourceForeground"], originalColors["terminal.ansiGreen"], originalColors["editorGutter.addedBackground"]));
	fill(colors, "gitDecoration.modifiedResourceForeground", firstColor(originalColors["gitDecoration.modifiedResourceForeground"], originalColors["terminal.ansiBlue"], originalColors["editorGutter.modifiedBackground"]));
	fill(colors, "gitDecoration.deletedResourceForeground", firstColor(originalColors["gitDecoration.deletedResourceForeground"], originalColors["terminal.ansiRed"], originalColors["editorGutter.deletedBackground"]));
	const focusRing = (isFullyTransparent(originalColors["list.focusOutline"]) ? void 0 : originalColors["list.focusOutline"]) ?? (isFullyTransparent(originalColors["focusBorder"]) ? void 0 : originalColors["focusBorder"]);
	if (focusRing != null) colors["list.focusOutline"] = focusRing;
	else delete colors["list.focusOutline"];
	const hover = originalColors["list.hoverBackground"];
	if (hover != null && (matchesSurface(hover, sidebarBackground) || hoverWouldEraseText(hover, sidebarBackground, sidebarForeground))) delete colors["list.hoverBackground"];
	const result = Object.freeze({
		...theme,
		colors: Object.freeze(colors)
	});
	cache.set(theme, result);
	return result;
}
function fill(colors, key, value) {
	if (value != null && value !== "") colors[key] = value;
}
function firstColor(...candidates) {
	for (const candidate of candidates) if (candidate != null && candidate !== "") return candidate;
}
function matchesSurface(color, surface) {
	return surface != null && color.toLowerCase() === surface.toLowerCase();
}

//#endregion
export { normalizeThemeColors };
//# sourceMappingURL=normalizeThemeColors.js.map